<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Por cliente
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Máquinas</span>
      <span> /</span>
      <span class="grey-text">Reportes</span>
      <span> /</span>
      <span>Por cliente</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col" style="max-width: 150px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Fecha'" required
              formControlName="fechaDesde"></mdb-date-picker>
          </div>
        </div>
        <div class="col" style="max-width: 150px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" required
              formControlName="fechaHasta"></mdb-date-picker>
          </div>
        </div>
        <div class="col" style="max-width: 200px">
          <div class="form-check p-0">
            <input type="radio" class="form-check-input" id="rbVistaResumen" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_RESUMEN" />
            <label class="form-check-label" for="rbVistaResumen">Vista Resumen</label>
          </div>
          <div class="form-check p-0">
            <input type="radio" class="form-check-input" id="rbVistaDetalle" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_DETALLE" />
            <label class="form-check-label" for="rbVistaDetalle">Vista Detallada</label>
          </div>
        </div>
        <div [ngClass]="{'col': true}" style="max-width: 150px; margin-top: 7px;">
          <div class="md-form">
            <input value="" type="text" id="rutcliente" class="form-control" placeholder="9.999.999-9" required
              #rutcliente formControlName="rutCliente" formatRut />
            <label for="rutcliente">Rut cliente</label>
          </div>
        </div>
        <div [ngClass]="{'col d-flex': true}" style="max-width: 300px">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="openModalSeleccionarcliente()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents" *ngIf=" cliente">
            {{ cliente.razon_social }}
          </h6>
        </div>
        <div class="col" style="max-width: 250px;">
          <!-- <mdb-checkbox formControlName="todos">Todos</mdb-checkbox> -->
          <mdb-checkbox formControlName="ClientesConVenta">Clientes Con Ventas</mdb-checkbox>
          <mdb-checkbox formControlName="soloClientesSinVenta">Clientes Sin Ventas</mdb-checkbox>
        </div>
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsRubro" (ngModelChange)="onChangeRubro($event)" [multiple]="true"
              [filterEnabled]="true" [highlightFirst]="false" placeholder="Todos"
              formControlName="listaRubro"></mdb-select>
            <label>Rubro</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsVendedor" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Vendedor" formControlName="vendedor"></mdb-select>
            <label>Vendedor</label>
          </div>
        </div>
        <!-- <div class="col" style="max-width: 250px;" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN">
          <mdb-checkbox formControlName="soloClientesSinVenta">solo clientes sin ventas</mdb-checkbox>
        </div> -->


      </div>
      <div class="row filtros-body" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
        <div class="col" style="max-width: 180px">
          <div class="md-form">
            <!-- <mdb-select [options]="optionsVendedor" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
                        placeholder="Seleccionar Vendedor" formControlName="vendedor"></mdb-select>
                      <label>Vendedor</label> -->
            <mdb-select [options]="optionsFamilia" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Familia" formControlName="familia"></mdb-select>
            <label>Familia</label>
          </div>
        </div>

        <div class="col" style="max-width: 180px">
          <div class="md-form">
            <mdb-select [options]="optionsEstado" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Estado" formControlName="estado"></mdb-select>
            <label>Estado</label>
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<div class="card mb-2 wow">
  <div class="card-body justify-content-between">
    <!-- RESUMEN -->
    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN">
      <mdb-spinner spinnerColor="blue" *ngIf="resumen_loading"></mdb-spinner>
      <app-no-data-alert *ngIf="resumen_listaMovimientos?.length === 0"></app-no-data-alert>

      <table class="table table-striped table-hover table-sm align-middle" *ngIf="resumen_listaMovimientos?.length > 0">
        <thead class="grey lighten-2">
          <tr>
            <!-- <th scope="col">Cod. Sucursal</th> -->
            <th scope="col">Rut</th>
            <th scope="col">Cliente</th>
            <th scope="col">Dirección</th>
            <th scope="col">Comuna</th>
            <th scope="col">Ciudad</th>
            <th scope="col">Vendedor</th>
            <th scope="col">Máq.</th>
            <th scope="col">Ventas</th>
            <th scope="col">Vtas. x Máq.</th>
            <th scope="col">Territorio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center" *ngIf="resumen_loading">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
            <td colspan="100%" style="text-align: center"
              *ngIf="!resumen_loading && resumen_listaMovimientos?.length === 0">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let mov of resumen_listaMovimientos">
            <!-- <td>{{mov.codigo_sucursal}}</td> -->
            <ng-container>
              <!-- <tr  class="grey lighten-3">
                <td colspan="2" style="font-weight: bold;"><b>{{listaDev.codigoFamilia}}</b></td>
                <td colspan="2"><b></b></td>
                <td><b></b></td>
              </tr>
              <tr *ngFor="let list of listaDev.groupItem">
                <td>{{list.sku}}</td>
                <td>{{list.descripcion}}</td>
                <td>{{list.formato}}</td>
                <td class="text-right">{{list.bultos}}</td>
                <td class="text-right">{{list.unidades}}</td>
              </tr> -->
            </ng-container>
            <td>{{mov.rutFormato | rut}}</td>
            <td>{{mov.cliente}}</td>
            <td>{{mov.direccion}}</td>
            <td>{{mov.nombre_comuna}}</td>
            <td>{{mov.nombre_ciudad}}</td>
            <td>{{mov.vendedor_codigo}}</td>
            <td>{{mov.conteo_total}}</td>
            <td>{{mov.monto_total | numerico}}</td>
            <td>{{mov.monto_maquina | numerico}}</td>
            <td>{{mov.territorio}}</td>
          </tr>
        </tbody>
        <app-pagination [context]="resumen_paginationContext" (onPageChange)="resumenOnPageChange($event)"
          *ngIf="resumen_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>

    <!-- DETALLE -->
    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
      <mdb-spinner spinnerColor="blue" *ngIf="detalle_loading"></mdb-spinner>
      <app-no-data-alert *ngIf="detalle_listaMovimientos?.length === 0"></app-no-data-alert>
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="detalle_listaMovimientos?.length > 0">
        <thead class="grey lighten-2">
          <tr>
            <!-- <th scope="col">Cod. Sucursal</th> -->
            <th scope="col">Rut</th>
            <th scope="col">Cliente</th>
            <th scope="col">Dirección</th>
            <th scope="col">Comuna</th>
            <th scope="col">Ciudad</th>
            <th scope="col">Vendedor</th>
            <th scope="col">Nro. Placa</th>
            <th scope="col">Marca</th>
            <th scope="col">Modelo</th>
            <th scope="col">F. Asignacion</th>
            <th scope="col">Nro. Contrato</th>
            <th scope="col">G. Despac.</th>
            <th scope="col">Estado</th>
            <th scope="col">Máq.</th>
            <th scope="col">Ventas</th>
            <th scope="col">Vtas. x Máq.</th>
            <th scope="col">Territorio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center" *ngIf="detalle_loading">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
            <td colspan="100%" style="text-align: center"
              *ngIf="!detalle_loading && detalle_listaMovimientos?.length === 0">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let mov of detalle_listaMovimientos">
            <!-- <td>{{mov.codigo_sucursal}}</td> -->
            <td *ngIf="mov.cliente_proveedor_rut === 0"></td>
            <td *ngIf="mov.cliente_proveedor_rut != 0">{{mov.rutFormato | rut}}</td>
            <td>{{mov.cliente}}</td>
            <td>{{mov.direccion}}</td>
            <td>{{mov.nombre_comuna}}</td>
            <td>{{mov.nombre_ciudad}}</td>
            <td>
              <span *ngIf="mov.vendedor_codigo === 0"></span>
              <span *ngIf="mov.vendedor_codigo > 0">{{mov.vendedor_codigo}}</span>
            </td>
            <td>{{mov.placa}}</td>
            <td>{{mov.marca}}</td>
            <td>{{mov.modelo}}</td>
            <td>{{mov.fecha_ult_asignacion | fecha}}</td>
            <td>{{mov.numero_contrato}}</td>
            <td>{{mov.guia_despacho}}</td>
            <td>
              <mdb-badge *ngIf="mov.estado_maquina_codigo === 1" pill="true" success="true">
                {{mov.estado}}</mdb-badge>
              <mdb-badge *ngIf="mov.estado_maquina_codigo === 2" pill="true" info="true">{{mov.estado}}
              </mdb-badge>
              <mdb-badge *ngIf="mov.estado_maquina_codigo === 3" pill="true" warning="true">
                {{mov.estado}}</mdb-badge>
              <mdb-badge *ngIf="mov.estado_maquina_codigo === 4" pill="true" danger="true">{{mov.estado}}
              </mdb-badge>
              <mdb-badge *ngIf="mov.estado_maquina_codigo === 0" pill="true" danger="true">{{mov.estado}}
              </mdb-badge>
            </td>
            <td *ngIf="mov.cliente_proveedor_rut === 0"></td>
            <td *ngIf="mov.cliente_proveedor_rut != 0">{{mov.conteo_total}}</td>
            <td>
              <span *ngIf="mov.monto_total > 0">{{mov.monto_total | numerico}}</span>
            </td>
            <td>{{mov.monto_maquina | numerico}}</td>
            <td *ngIf="mov.cliente_proveedor_rut === 0"></td>
            <td *ngIf="mov.cliente_proveedor_rut != 0">{{mov.territorio}}</td>
          </tr>
        </tbody>
        <app-pagination [context]="detalle_paginationContext" (onPageChange)="detalleOnPageChange($event)"
          *ngIf="detalle_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN && resumen_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="downloadExcelPdfResumen('XLS')">
      Excel
    </button>
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="downloadExcelPdfResumen('PDF')">
      PDF
    </button>
  </div>
</div>

<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE && detalle_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="downloadExcelPdfDetalle('XLS')">
      Excel
    </button>
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="downloadExcelPdfDetalle('PDF')">
      PDF
    </button>
  </div>
</div>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" queryType="ONLY_RUT" (onSelectSingle)="onClienteSeleccionado($event)">
</app-modal-seleccionar-cliente>